import { render } from "./CookiesNav.vue?vue&type=template&id=908c8da4&scoped=true"
import script from "./CookiesNav.vue?vue&type=script&lang=js"
export * from "./CookiesNav.vue?vue&type=script&lang=js"

import "./CookiesNav.vue?vue&type=style&index=0&id=908c8da4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908c8da4"]])

export default __exports__